// removed by extract-text-webpack-plugin
module.exports = {"root":"NoResults-module-root-2_CGS","text":"NoResults-module-text-GUpi0","title":"NoResults-module-title-2EXr0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NoResults/NoResults.module.scss
// module id = 939
// module chunks = 0